import { cn } from '../../utils';
import { Checkbox } from '../Checkbox';

export interface FilterChoiceRowProps {
  /** `checkbox` for a multi-select list, `radio` for one choice */
  type: 'checkbox' | 'radio';
  /** Radio group name */
  name?: string;
  label: string;
  description?: string;
  checked: boolean;
  onChange: () => void;
  testId?: string;
}

/** One selectable row of a filter editor (internal to the filter bar). */
export const FilterChoiceRow = ({
  type,
  name,
  label,
  description,
  checked,
  onChange,
  testId
}: FilterChoiceRowProps) => (
  <label
    className={cn(
      'flex items-center gap-sm px-sm py-xs rounded-md cursor-pointer text-sm text-foreground-base',
      'hover:bg-background-muted transition-colors'
    )}
  >
    {type === 'checkbox' ? (
      <Checkbox checked={checked} onChange={() => onChange()} testId={testId} />
    ) : (
      <input
        type='radio'
        name={name}
        checked={checked}
        onChange={() => onChange()}
        data-testid={testId}
        className='w-4 h-4 shrink-0 accent-primary-base cursor-pointer'
      />
    )}
    <span className='min-w-0 truncate'>{label}</span>
    {description && (
      <span className='ml-auto shrink-0 text-xs text-foreground-muted'>{description}</span>
    )}
  </label>
);
